export const chargePointStatusEnum = {
  Disconnected: "Disconnected",
  Connected: "Connected",
};
